<template>
    <b-tabs pills active-nav-item-class="nav-pill-success">
        <b-tab title="Özet Görünüm" active>
            <div class="row">
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Taslak Fiyat Bilgileri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Çalışma Şekli</th>
                                <th class="w-50">Taslak Kodu</th>
                                <th class="w-50">Firma</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{getTypeStr(value.PriceType)}}</td>
                                <td>{{value.DraftCode}}</td>
                                <td>{{value.FirmName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Sözleşme Değerleri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <tbody>
                            <tr>
                                <th class="w-50">Sözleşme Süresi (Ay)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'AgreementDuration') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Vade (Gün)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'Maturity') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Yakıt Değişim Oranı (%)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'FuelPriceChangeRate') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Enflasyon Uygulama Süresi (Ay)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'InflationChangeDuration') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Teklif Son Gerçerlilik Tarihi</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'DraftOfferExpireDateStr') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Araç Bekleme Zaman Aşımı</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'UnloadingTime') || "-"}} {{$safe(value.AgreementValue,'UnloadingTimeTypeStr') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Araç Günlük Bekleme Ücreti (TL)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'UnloadingTimeFaulPrice') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Araç Boş Taşıma Ücreti (TL)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'EmptyTransportPrice') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Donmuş Ürün Sıcaklığı (℃)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'FrozenProductTemperature') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Tutar Yansıtma Oranları 
                                    <template v-if="!$safe(value.AgreementValue,'IsHaveFraction')">(%)</template>
                                </th>
                                <td class="w-50">
                                    <template v-if="$safe(value.AgreementValue,'IsHaveFraction')">
                                        Yakıt: {{$safe(value.AgreementValue,'FractionNumeratorOfFuelPrice')}}/{{$safe(value.AgreementValue,'FractionDenominator')}} - 
                                        Enflasyon: {{$safe(value.AgreementValue,'FractionNumeratorOfInflationPrice')}}/{{$safe(value.AgreementValue,'FractionDenominator')}}
                                    </template>
                                    <template v-else>
                                        Yakıt: {{$safe(value.AgreementValue,'RateOfFuelPrice')}} - 
                                        Enflasyon: {{$safe(value.AgreementValue,'RateOfInflationPrice')}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-50">Tüfe / Üfe Yansıtma Oranları
                                    <template v-if="!$safe(value.AgreementValue,'IsTufeUfeHaveFraction')">(%)</template>
                                </th>
                                <td class="w-50">
                                    <template v-if="$safe(value.AgreementValue,'IsTufeUfeHaveFraction')">
                                        Tüfe: {{$safe(value.AgreementValue,'FractionNumeratorOfTufe')}}/{{$safe(value.AgreementValue,'TufeUfeFractionDenominator')}} - 
                                        Üfe: {{$safe(value.AgreementValue,'FractionNumeratorOfUfe')}}/{{$safe(value.AgreementValue,'TufeUfeFractionDenominator')}}
                                    </template>
                                    <template v-else>
                                        Tüfe: {{$safe(value.AgreementValue,'RateOfTufe')}} - 
                                        Üfe: {{$safe(value.AgreementValue,'RateOfUfe')}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-50">Birinci Bölüm Alt Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment1TemperatureLowerLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Birinci Bölüm Üst Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment1TemperatureUpperLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">İkinci Bölüm Alt Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment2TemperatureLowerLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">İkinci Bölüm Üst Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment2TemperatureUpperLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Bekleme Referans Saati</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'WaitReferenceTime') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Enflasyon Türü</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'InflationParameterTypeStr') || "-"}}</td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Yakıt Bilgileri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>Yakıt Markası</th>
                                <th>Yakıt Tipi</th>
                                <th>Yakıt Şehri</th>
                                <th>Yakıt İlçesi</th>
                                <th>Yakıt Fiyatı (TL)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{value.FuelBrandName}}</td>
                                <td>{{value.FuelGroupName}}</td>
                                <td>{{value.FuelPriceProvinceName}}</td>
                                <td>{{value.FuelPriceDistrictName}}</td>
                                <td>{{value.CurrentFuelPriceStr}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <h5 class="font-weight-bolder">Rota Bilgileri</h5>
                    <div class="table-responsive" v-if="value.PriceType == 0">
                        <table class="table table-bordered table-sm">    
                            <thead>
                                <tr>
                                    <th></th>
                                    <th colspan="2" class="text-nowrap">Başlangıç</th>
                                    <th colspan="2" class="text-nowrap">Bitiş</th>
                                    <th colspan="2" class="text-nowrap">Aylak Rota</th>
                                    <th colspan="20"></th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model">Ref. Mod.</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK (TON)</th>
                                    <th class="text-nowrap">Mesafe (KM)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Çalışma Gün Sayısı">ÇGS</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sefer Sayısı">SS</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM (TL/Gün)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM (TL/TON-KM)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN (TL/TON)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kar Oranı">RMKO (%)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı İle Satış Fiyatı">KOSF (TL/TON)</th>
                                    <th class="text-nowrap">KAR (TL/TON)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(route,index) in value.Routes" :key="'r'+index">
                                    <td class="text-nowwrap">{{route.VehicleReferenceModelManuelName}}</td>
                                    <td class="text-nowwrap">{{route.StartProvinceName}}</td>
                                    <td class="text-nowwrap">{{route.StartDistrictName}}</td>
                                    <td class="text-nowwrap">{{route.EndProvinceName}}</td>
                                    <td class="text-nowwrap">{{route.EndDistrictName}}</td>
                                    <td class="text-nowwrap">{{route.IdleProvinceName || '-'}}</td>
                                    <td class="text-nowwrap">{{route.IdleDistrictName || '-'}}</td>
                                    <td class="text-nowwrap">{{route.CurrentVehicleRefModelVehicleCapacity}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'DistanceKm')}}</td>
                                    <td class="text-nowwrap">{{route.CountOfDaysWorked}}</td>
                                    <td class="text-nowwrap">{{route.CountOfTrips}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'FixedCostStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'TotalTireUnitCostStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'BreakevenPointTonStr')}}</td>
                                    <td class="text-nowwrap">{{route.CurrentVehicleRefProfitRate}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'SalesPriceWithProfitRateTonStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'AmountOfProfitStr')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive mb-0" v-if="value.PriceType == 1">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th colspan="2" class="text-nowrap">Başlangıç</th>
                                    <th colspan="2" class="text-nowrap">Bitiş</th>
                                    <th colspan="2" class="text-nowrap">Aylak Rota</th>
                                    <th colspan="20"></th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model">Ref. Mod.</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK (TON)</th>
                                    <th>Mesafe (KM)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Çalışma Gün Sayısı">ÇGS</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sefer Sayısı">SS</th>
                                    <th v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM (TL/Gün)</th>
                                    <th v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM (TL/TON-KM)</th>
                                    <th v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN (TL/KM)</th>
                                    <th v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kar Oranı">RMKO (%)</th>
                                    <th v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı İle Satış Fiyatı">KOSF (TL/KM)</th>
                                    <th>KAR (TL/KM)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(route,index) in value.Routes" :key="'r'+index">
                                    <td class="text-nowwrap">{{route.VehicleReferenceModelManuelName}}</td>
                                    <td class="text-nowwrap">{{route.StartProvinceName}}</td>
                                    <td class="text-nowwrap">{{route.StartDistrictName}}</td>
                                    <td class="text-nowwrap">{{route.EndProvinceName}}</td>
                                    <td class="text-nowwrap">{{route.EndDistrictName}}</td>
                                    <td class="text-nowwrap">{{route.IdleProvinceName || '-'}}</td>
                                    <td class="text-nowwrap">{{route.IdleDistrictName || '-'}}</td>
                                    <td class="text-nowwrap">{{route.CurrentVehicleRefModelVehicleCapacity}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'DistanceKm')}}</td>
                                    <td class="text-nowwrap">{{route.CountOfDaysWorked}}</td>
                                    <td class="text-nowwrap">{{route.CountOfTrips}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'FixedCostStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'TotalTireUnitCostStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'BreakevenPointKmStr')}}</td>
                                    <td class="text-nowwrap">{{route.CurrentVehicleRefProfitRate}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'SalesPriceWithProfitRateKmStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'AmountOfProfitStr')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive mb-0" v-if="value.PriceType == 2">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th colspan="2" class="text-nowrap">Başlangıç</th>
                                    <th colspan="2" class="text-nowrap">Bitiş</th>
                                    <th colspan="2" class="text-nowrap">Aylak Rota</th>
                                    <th colspan="20"></th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model">Ref. Mod.</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap">İl</th>
                                    <th class="text-nowrap">İlçe</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK (TON)</th>
                                    <th class="text-nowrap">Mesafe (KM)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Çalışma Gün Sayısı">ÇGS</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sefer Sayısı">SS</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM (TL/Gün)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM (TL/TON-KM)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN (TL/Rota)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kar Oranı">RMKO (%)</th>
                                    <th class="text-nowrap" v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı İle Satış Fiyatı">KOSF (TL/Rota)</th>
                                    <th class="text-nowrap">KAR (TL/Rota)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(route,index) in value.Routes" :key="'r'+index">
                                    <td class="text-nowwrap">{{route.VehicleReferenceModelManuelName}}</td>
                                    <td class="text-nowwrap">{{route.StartProvinceName}}</td>
                                    <td class="text-nowwrap">{{route.StartDistrictName}}</td>
                                    <td class="text-nowwrap">{{route.EndProvinceName}}</td>
                                    <td class="text-nowwrap">{{route.EndDistrictName}}</td>
                                    <td class="text-nowwrap">{{route.IdleProvinceName || '-'}}</td>
                                    <td class="text-nowwrap">{{route.IdleDistrictName || '-'}}</td>
                                    <td class="text-nowwrap">{{route.CurrentVehicleRefModelVehicleCapacity}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'DistanceKm')}}</td>
                                    <td class="text-nowwrap">{{route.CountOfDaysWorked}}</td>
                                    <td class="text-nowwrap">{{route.CountOfTrips}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'FixedCostStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'TotalTireUnitCostStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'TotalCostStr')}}</td>
                                    <td class="text-nowwrap">{{route.CurrentVehicleRefProfitRate}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'LastTotalRevenueWithProfitRateStr')}}</td>
                                    <td class="text-nowwrap">{{getCurrentRootValue(route,'AmountOfProfitStr')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-tab>
        <b-tab title="Detay Görünüm">
            <div class="row">
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Taslak Fiyat Bilgileri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Çalışma Şekli</th>
                                <th class="w-50">Taslak Kodu</th>
                                <th class="w-50">Firma</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{getTypeStr(value.PriceType)}}</td>
                                <td>{{value.DraftCode}}</td>
                                <td>{{value.FirmName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Sözleşme Değerleri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <tbody>
                            <tr>
                                <th class="w-50">Sözleşme Süresi (Ay)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'AgreementDuration') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Vade (Gün)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'Maturity') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Yakıt Değişim Oranı (%)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'FuelPriceChangeRate') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Enflasyon Uygulama Süresi (Ay)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'InflationChangeDuration') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Teklif Son Gerçerlilik Tarihi</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'DraftOfferExpireDateStr') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Araç Bekleme Zaman Aşımı</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'UnloadingTime') || "-"}} {{$safe(value.AgreementValue,'UnloadingTimeTypeStr') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Araç Günlük Bekleme Ücreti (TL)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'UnloadingTimeFaulPrice') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Araç Boş Taşıma Ücreti (TL)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'EmptyTransportPrice') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Donmuş Ürün Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'FrozenProductTemperature') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Tutar Yansıtma Oranları 
                                    <template v-if="!$safe(value.AgreementValue,'IsHaveFraction')">(%)</template>
                                </th>
                                <td class="w-50">
                                    <template v-if="$safe(value.AgreementValue,'IsHaveFraction')">
                                        Yakıt: {{$safe(value.AgreementValue,'FractionNumeratorOfFuelPrice')}}/{{$safe(value.AgreementValue,'FractionDenominator')}} - 
                                        Enflasyon: {{$safe(value.AgreementValue,'FractionNumeratorOfInflationPrice')}}/{{$safe(value.AgreementValue,'FractionDenominator')}}
                                    </template>
                                    <template v-else>
                                        Yakıt: {{$safe(value.AgreementValue,'RateOfFuelPrice')}} - 
                                        Enflasyon: {{$safe(value.AgreementValue,'RateOfInflationPrice')}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-50">Tüfe / Üfe Yansıtma Oranları
                                    <template v-if="!$safe(value.AgreementValue,'IsTufeUfeHaveFraction')">(%)</template>
                                </th>
                                <td class="w-50">
                                    <template v-if="$safe(value.AgreementValue,'IsTufeUfeHaveFraction')">
                                        Tüfe: {{$safe(value.AgreementValue,'FractionNumeratorOfTufe')}}/{{$safe(value.AgreementValue,'TufeUfeFractionDenominator')}} - 
                                        Üfe: {{$safe(value.AgreementValue,'FractionNumeratorOfUfe')}}/{{$safe(value.AgreementValue,'TufeUfeFractionDenominator')}}
                                    </template>
                                    <template v-else>
                                        Tüfe: {{$safe(value.AgreementValue,'RateOfTufe')}} - 
                                        Üfe: {{$safe(value.AgreementValue,'RateOfUfe')}}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-50">Birinci Bölüm Alt Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment1TemperatureLowerLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Birinci Bölüm Üst Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment1TemperatureUpperLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">İkinci Bölüm Alt Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment2TemperatureLowerLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">İkinci Bölüm Üst Sıcaklığı (°C)</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'VehicleCompartment2TemperatureUpperLimit') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Bekleme Referans Saati</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'WaitReferenceTime') || "-"}}</td>
                            </tr>
                            <tr>
                                <th class="w-50">Enflasyon Türü</th>
                                <td class="w-50">{{$safe(value.AgreementValue,'InflationParameterTypeStr') || "-"}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Yakıt Bilgileri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>Yakıt Markası</th>
                                <th>Yakıt Tipi</th>
                                <th>Yakıt Şehri</th>
                                <th>Yakıt İlçesi</th>
                                <th>Yakıt Fiyatı (TL)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{value.FuelBrandName}}</td>
                                <td>{{value.FuelGroupName}}</td>
                                <td>{{value.FuelPriceProvinceName}}</td>
                                <td>{{value.FuelPriceDistrictName}}</td>
                                <td>{{value.CurrentFuelPriceStr}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <h5 class="font-weight-bolder">Rota Bilgileri</h5>
                    <div class="table-responsive mb-0">
                        <table class="table table-sm mb-0">
                            <thead>
                                <th>Referans Model</th>
                                <th v-b-tooltip.noninteractive.hover.bottom title="Referans Model Kar Oranı">RMKO <span class="text-muted">(%)</span></th>
                                <th v-b-tooltip.noninteractive.hover.bottom title="Referans Model Araç Kapasitesi">RMAK <span class="text-muted">(TON)</span></th>
                                <th>Başlangıç İli</th>
                                <th>Başlangıç İlçesi</th>
                                <th>Varış İli</th>
                                <th>Varış İlçesi</th>
                                <th>Aylak Rota İli</th>
                                <th>Aylak Rota İlçesi</th>
                                <th>Çalışılan Gün Sayısı</th>
                                <th>Sefer Sayısı</th>
                            </thead>
                            <tbody>
                                <template v-for="(item,index) in value.Routes">
                                    <tr :key="'main-' + index">
                                        <td>{{item.VehicleReferenceModelManuelName}}</td>
                                        <td>{{item.CurrentVehicleRefProfitRate}}</td>
                                        <td>{{item.CurrentVehicleRefModelVehicleCapacity}}</td>
                                        <td>{{item.StartProvinceName}}</td>
                                        <td>{{item.StartDistrictName}}</td>
                                        <td>{{item.EndProvinceName}}</td>
                                        <td>{{item.EndDistrictName}}</td>
                                        <td>{{item.IdleProvinceName || '-'}}</td>
                                        <td>{{item.IdleDistrictName || '-'}}</td>
                                        <td>{{item.CountOfDaysWorked}}</td>
                                        <td>{{item.CountOfTrips}}</td>
                                    </tr>
                                    <tr :key="'sub-' + index">
                                        <td colspan="100">
                                            <div class="table-responsive mb-0">
                                                <table class="table table-bordered table-sm mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th></th>
                                                            <th colspan="2" class="text-center bg-light-danger">Maliyet Hesabı</th>
                                                            <th colspan="6" class="text-center bg-light-secondary">Başabaş Noktası Analizi</th>
                                                            <th colspan="5" class="text-center bg-light-warning">Kar Oranı İle Hesaplananlar</th>
                                                            <th></th>
                                                        </tr>
                                                        <tr>
                                                            <th>Mesafe Kaynağı</th>
                                                            <th>Mesafe<br/><span class="text-muted">(KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Sabit Maliyet">SM <br/><span class="text-muted">(TL)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Birim Değişken Maliyet">BDM <br/><span class="text-muted">(TL/TON-KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN <br/><span class="text-muted">(TL/TON-KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN <br/><span class="text-muted">(TL/TON)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası">BBN <br/><span class="text-muted">(TL/KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Toplam Gelir - Başabaş Noktası">BBN - TG <br/><span class="text-muted">(TL/Rota)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Toplam Maliyet - Başabaş Noktası">BBN - TM<br/><span class="text-muted">(TL/Rota)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Başabaş Noktası Kar">BBNK <br/><span class="text-muted">(TL/TON-KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı ile Satış Fiyatı">KOSF <br/><span class="text-muted">(TL/TON-KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı ile Satış Fiyatı">KOSF <br/><span class="text-muted">(TL/TON)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı ile Satış Fiyatı">KOSF <br/><span class="text-muted">(TL/KM)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Kar Oranı ile Satış Fiyatı">KOSF <br/><span class="text-muted">(TL/Rota)</span></th>
                                                            <th v-b-tooltip.noninteractive.hover.bottom title="Toplam Maliyet">TM <br/><span class="text-muted">(TL/Rota)</span></th>
                                                            <th>Kar <br/><span class="text-muted">(TL/Rota)</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(subItem,index) in item.RoutePrices">
                                                            <tr :key="index" :class="getClass(subItem.RoutePriceTypeStr,index,item.RoutePrices.length)">
                                                                <td class="text-nowrap">{{getName(subItem.RoutePriceTypeStr)}}</td>
                                                                <td class="text-right">{{subItem.DistanceKm}}</td>
                                                                <td class="text-right">{{subItem.FixedCostStr}}</td>
                                                                <td class="text-right">{{subItem.TotalTireUnitCostStr}}</td>
                                                                <td class="text-right">{{subItem.BreakevenPointCostTonKmStr}}</td>
                                                                <td class="text-right">{{subItem.BreakevenPointTonStr}}</td>
                                                                <td class="text-right">{{subItem.BreakevenPointKmStr}}</td>
                                                                <td class="text-right">{{subItem.BreakevenPointTotalRevenueStr}}</td>
                                                                <td class="text-right">{{subItem.TotalCostStr}}</td>
                                                                <td class="text-right">{{subItem.BreakevenPointTonKmStr}}</td>
                                                                <td class="text-right">{{subItem.SalesPriceWithProfitRateCostTonKmStr}}</td>
                                                                <td class="text-right">
                                                                    <div class="d-flex align-items-center" :class="showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 0 ? 'justify-content-between':'justify-content-end'">
                                                                        <span v-if="showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 0" class="material-icons-outlined text-success mr-50" v-b-tooltip.noninteractive.hover.bottom title="Müşteri Fiyatı">check_circle</span>
                                                                        <span :class="{'font-weight-bolder':showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 0}">{{subItem.SalesPriceWithProfitRateTonStr}}</span>
                                                                    </div>
                                                                </td>
                                                                <td class="text-right">
                                                                    <div class="d-flex align-items-center" :class="showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 1 ? 'justify-content-between':'justify-content-end'">
                                                                        <span v-if="showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 1" class="material-icons-outlined text-success mr-50" v-b-tooltip.noninteractive.hover.bottom title="Müşteri Fiyatı">check_circle</span>
                                                                        <span :class="{'font-weight-bolder':showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 1}">{{subItem.SalesPriceWithProfitRateKmStr}}</span>
                                                                    </div>
                                                                </td>
                                                                <td class="text-right">
                                                                    <div class="d-flex align-items-center" :class="showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 2 ? 'justify-content-between':'justify-content-end'">
                                                                        <span v-if="showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 2" class="material-icons-outlined text-success mr-50" v-b-tooltip.noninteractive.hover.bottom title="Müşteri Fiyatı">check_circle</span>
                                                                        <span :class="{'font-weight-bolder':showCheck(subItem.RoutePriceTypeStr,index,item.RoutePrices.length) && value.PriceType == 2}">{{subItem.LastTotalRevenueWithProfitRateStr}}</span>
                                                                    </div>
                                                                </td>
                                                                <td class="text-right">{{subItem.TotalCostWithProfitRateStr}}</td>
                                                                <td class="text-right">{{subItem.AmountOfProfitStr}}</td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-tab>
    </b-tabs>

</template>

<script>
import { VBTooltip,BTabs,BTab } from 'bootstrap-vue'

export default {
    components:{
        BTabs,
        BTab
    },
    props:{
        value:Object
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    methods:{
        getName(str){
            switch(str){
                case 'CustomerKm': return 'Mesafe-A [Müşteri]'
                case 'GoogleKm': return this.value.PriceType == 2 ? 'Mesafe-B [Harita]' : 'Mesafe'
                case 'IdleRouteKm': return 'Mesafe-C [Aylak]'
                default: return str
            }
        },
        getClass(str,index,length){
            switch(str){
                case 'CustomerKm': return 'calculated-routes-yellow'
                case 'GoogleKm': return index == length - 2 ? 'calculated-routes-orange' : 'calculated-routes-green'
                case 'IdleRouteKm': return 'calculated-routes-green'
                default: return str
            }
        },
        showCheck(str,index,length){
            switch(str){
                case 'CustomerKm': return false
                case 'GoogleKm': return index == length - 2 ? false : true
                case 'IdleRouteKm': return true
                default: return str
            }
        },
        getTypeStr(type){
            switch(type){
                case 0: return 'TL/TON' 
                case 1: return 'TL/KM' 
                case 2: return 'ROTA' 
                default: return 'ROTA'
            }
        },
        getCurrentRootValue(route,value){
            let customer = route.RoutePrices.find(r=> r.RoutePriceType == 0)
            let google = route.RoutePrices.find(r=> r.RoutePriceType == 1)
            let idle = route.RoutePrices.find(r=> r.RoutePriceType == 2)
            let current = idle ? idle : google ? google : customer
            return this.$safe(current,value) || "-"
        }
    }
}
</script>

<style>
.calculated-routes-yellow{
    background-color: rgba(255, 193, 7,0.5);
}
.calculated-routes-green{
    background-color: rgba(40, 199, 111,0.5);
}
.calculated-routes-orange{
    background-color: rgba(255, 159, 67,0.5);
}
</style>